'use client';
import { datadogRum } from '@datadog/browser-rum';
import { type PropsWithChildren, useEffect, useRef } from 'react';

export function CaptureAppHydratedTiming({ children }: PropsWithChildren) {
  const addedTimerRef = useRef(false);
  useEffect(() => {
    if (!addedTimerRef.current) {
      datadogRum.addTiming('app_hydrated');
      addedTimerRef.current = true;
    }
  }, []);

  return children;
}
